module.exports = "/assets/hero-rw-mobile@2x.png?b5OUb7p";